var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGpsWhiteico(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.12732 14.2156C5.12732 14.2156 0 9.89738 0 5.64839C0 4.15034 0.595096 2.71365 1.65437 1.65437C2.71365 0.595096 4.15034 0 5.64839 0C7.14643 0 8.58312 0.595096 9.6424 1.65437C10.7017 2.71365 11.2968 4.15034 11.2968 5.64839C11.2968 9.89738 6.16945 14.2156 6.16945 14.2156C5.8842 14.4782 5.41468 14.4754 5.12732 14.2156ZM5.64839 8.11955C5.9729 8.11955 6.29424 8.05564 6.59406 7.93145C6.89388 7.80726 7.1663 7.62523 7.39576 7.39576C7.62523 7.1663 7.80726 6.89388 7.93145 6.59406C8.05564 6.29424 8.11955 5.9729 8.11955 5.64839C8.11955 5.32387 8.05564 5.00253 7.93145 4.70271C7.80726 4.40289 7.62523 4.13047 7.39576 3.90101C7.1663 3.67154 6.89388 3.48951 6.59406 3.36532C6.29424 3.24114 5.9729 3.17722 5.64839 3.17722C4.99299 3.17722 4.36444 3.43757 3.90101 3.90101C3.43757 4.36444 3.17722 4.99299 3.17722 5.64839C3.17722 6.30378 3.43757 6.93233 3.90101 7.39576C4.36444 7.8592 4.99299 8.11955 5.64839 8.11955Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsWhiteico);
export default __webpack_public_path__ + "static/media/gps-whiteico.5d4a179cc38ffe805e9591caac8d5a65.svg";
export { ForwardRef as ReactComponent };